var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      _vm.isBusy
        ? _c("loading")
        : _vm.hasData
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-6" }, [
              _c("p", { staticClass: "el-style attribute-name" }, [
                _vm._v("Contact's message:"),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "message-content" }, [
                _vm._v(_vm._s(_vm.contactMessage)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6" }, [
              _c("p", { staticClass: "el-style attribute-name" }, [
                _vm._v("Staff's message:"),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "message-content" }, [
                _vm._v(_vm._s(_vm.staffMessage)),
              ]),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }